<template>
    <div v-redirect-if-no-permission:SERVICES>
        <DataTable :url="api.ACTIONS.SERVICES"
                   :fieldsHiddenMain='["deleted_at","active_price", "start_time", "end_time"]'
                   :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id","active_price", "start_time", "end_time"]'
                   :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id","active_price", "start_time", "end_time"]'
                   :formatter="formatter"
                   :actionsExtraMain="actionsExtraMain"
                   :fields-extra-add="extraEditor"
                   :fields-extra-edit="extraEditor"
                   :add-rules="rules(true)"
                   :edit-rules="rules(false)"
                   :titles="titles"
                   :title="$t('settings.servicesList.title')"/>
    </div>
</template>

<script>

    import DataTable from "@/components/monaco/DataTable";
    import i18n from "@/i18n";

    const number = value => {
        const pattern = /^\d+$/;
        if (!!value)
            return pattern.test(value) || i18n.t("settings.servicesList.mustBeNumber");
        else
            return true;
    };
    const required = value => !!value || i18n.t('settings.servicesList.required');

    export default {
        components: {DataTable},
        name: "Services",
        title() {
            return this.$t('settings.servicesList.title');
        },
        methods: {
            rules(add) {
                return {
                    max_bookings: [
                        number
                    ],
                    priority: add ? [
                        required, number
                    ] : [number],
                    name: add ? [
                        required
                    ] : [],
                    icon: add ? [
                        required
                    ] : []
                }
            },
        },
        computed: {

            extraEditor() {
                return {
                    icon: 'choose-image-single',
                    is_pooling: 'v-checkbox',
                    appearance_constrain: 'choose-appearance-constrain'
                }
            },
            formatter() {
                const api = this.api;
                const unloadable = this.$t("settings.servicesList.unloadable");
                const yes = this.$t("common.yes");
                const no = this.$t("common.no");
                return {
                    icon(value) {
                        if (value == null) return unloadable;
                        if (value[0] !== '/') value = "/" + value;
                        return `<img src="${api.IMAGES_URL + value}" class="img-thumbnail"/>`;
                    },
                    is_pooling(value) {
                        if (value) {
                            return yes;
                        }
                        return no;
                    }
                }
            },
            titles() {
                return {
                    "id": "#",
                    "max_bookings": this.$t("settings.servicesList.maxBookings"),
                    "created_at": this.$t("settings.servicesList.dateCreated"),
                    "updated_at": this.$t("settings.servicesList.dateUpdated"),
                    "appearance_constrain": this.$t("settings.servicesList.appearanceConstrain")
                }
            },
            actionsExtraMain() {
                return {

                    prices: {
                        icon: 'attach_money',
                        extras: {
                            color: '#85bb65'
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "ServicePrices",
                                params: {"id": item.id},
                                query: {"name": item.name}
                            })
                    },
                    captains: {
                        icon: 'directions_car',
                        extras: {
                            color: 'red'
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "ServiceCars",
                                params: {"id": item.id},
                                query: {"name": item.name}
                            })
                    },
                    locations: {
                        icon: 'location_on',
                        extras: {
                            color: "#8695bf"
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "ServiceLocations",
                                params: {"id": item.id},
                                query: {"name": item.name, appearance_constrain: item.appearance_constrain}
                            })
                    },
                }
            }
        }
    }
</script>

<style>
    .img-thumbnail {
        max-height: 40px;
        max-width: 40px;
    }
</style>